
<template>
  <v-form ref="form" v-model="valid" lazy-validation >
    <v-card flat>
      <v-card-title class="d-flex justify-center align-center">
        <v-tabs v-model="tab">
          <v-tab v-for="idx in contact_count">
            Contato {{ idx }}
          </v-tab>
        </v-tabs>
        <div >
          <v-btn icon v-if="contact_count > 1">
            <v-icon large @click="changeContactCount()"  color="error">mdi-minus</v-icon>
          </v-btn>
          <v-btn icon v-if="contact_count < limit">
            <v-icon large @click="changeContactCount(true)"  color="light-blue"
              >mdi-plus</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="idx in limit" :key="idx">
            <contact-form :ref="`form${idx}`" :contact="model.contacts[contact_map[idx]]" :includes_employee="includes_employee"></contact-form>      
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="emitChangeStepper(false)"><v-icon large color="red darken-2">mdi-arrow-up-bold</v-icon></v-btn>
        <v-btn text @click="emitChangeStepper(true)"><v-icon large color="green darken-2">mdi-arrow-down-bold</v-icon></v-btn>
      </v-card-actions>

    </v-card>
  </v-form>
</template>

<script>

import validations from "@/mixins/validations.js"
export default {
  name: 'StepperManyContacts',
  mixins:[ validations ],
  props:{
    model:{
      type: Object,
      default: () => { return {} }
    },
    limit:{
      type: Number,
      default: 5
    },
    includes_employee:{
      type: Boolean,
      default: false,
    }
  },
  components:{
    ContactForm: () => import("@/_backoffice/_registrations/components/shared/forms/ContactForm.vue"),
  },
  data() {
    return {
      valid: true,
      tab:0,
      contact_count: 1,
      contact_map:{
        1 : 'primary',
        2 : 'secondary', 
        3 : 'third', 
        4 : 'fourth', 
        5 : 'fifth', 
      }
    }
  },
  methods: {
    validate(){
      let is_valid = true 
      for(let idx = 1; idx <= this.contact_count; idx++){
        is_valid = is_valid && this.$refs[`form${idx}`][0]?.validate()
      }
      return is_valid
    },
    emitChangeStepper(increment){
      if(increment){
        this.prepareContacts()
      }
      this.$emit("changeStepper", increment)
    },
    prepareContacts() {
      this.model.contact_attributes = []
      for( let count = 1; count <= this.contact_count; count++ ){
        if(this.model?.contacts[this.contact_map[count]]?.name){
          this.model.contact_attributes.push( this.model.contacts[this.contact_map[count]] )
        }
      }
    },
    changeContactCount(increment) {
      if (increment) {
        this.contact_count = Math.min(this.contact_count + 1, this.limit);
      } else {
        if (this.contact_count === 2) {
          this.resetContact(this.model.contacts.secondary);
        } else if (this.contact_count === 3) {
          this.resetContact(this.model.contacts.third);
        } else if (this.contact_count === 4) {
          this.resetContact(this.model.contacts.fourth);
        } else if (this.contact_count === 5) {
          this.resetContact(this.model.contacts.fifth);
        }
        this.contact_count = Math.max(this.contact_count - 1, 1);
      }
    },
    resetContact(contact) {
      contact.name = null;
      contact.email = null;
      contact.celphone = null;
      contact.telephone = null;
      contact.position = null;
      contact.comment = null;
    },
  },
}
</script>